/**
 * Get In Touch Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initGetInTouch() {
        const blocks = document.querySelectorAll('.get-in-touch');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] get-in-touch block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGetInTouch);
    } else {
        initGetInTouch();
    }
})();